import { defineComponent, ref, inject, nextTick, watch, onMounted, onBeforeUnmount, openBlock, createElementBlock, Fragment, createBlock, resolveDynamicComponent, mergeProps, withCtx, renderSlot, Teleport, createElementVNode, normalizeClass, unref, normalizeStyle, createCommentVNode } from 'vue';
import request from '../../../utils/request.mjs';
import { USER_SYSTEM_API_HOST, DEVICE_TYPE, PLATFORM, CUSTOMER_TOKEN, ANYWHERE_URL, USER_LOGIN, USER_REGISTRATION, USER_MEMBERZONE, CUSTOMER_LOGOUT, USER_LOGOUT, PUBLIC_URL } from '../../../utils/getConstant.mjs';
import { getUuid, getDeviceInfo, getPublishTimestamp } from '../../../utils/index.mjs';
import { getCookie, deleteCookie } from '../../../utils/cookies.mjs';

const _hoisted_1 = { class: "tvb-anywhere-sso_dialog-container-loading" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const __default__ = defineComponent({
  name: "TvbAnywhereSsoButton"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    tag: null,
    type: null,
    animate: null
  },
  emits: [
    "loginSuccess",
    "devicesInit",
    "loginGuestSuccess",
    "userEvent",
    "close",
    "error"
  ],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const iframeSrc = ref("");
    const iframeShow = ref(false);
    const env = inject("env");
    const platform = inject("platform");
    const currentLanguage = inject("currentLanguage");
    const loginByLoading = inject("loginByLoading");
    const setLoginByLoading = inject("setLoginByLoading");
    const loginBySuccess = inject("loginBySuccess");
    const setLoginBySuccess = inject("setLoginBySuccess");
    const setLoginByWaiting = inject("setLoginByWaiting");
    const userInfo = inject("userInfo");
    const guestInfo = inject("guestInfo");
    const setUserInfo = inject("setUserInfo");
    const setGuestInfo = inject("setGuestInfo");
    const setDevices = inject("setDevices");
    const devicesInit = () => {
      return new Promise((resolve, reject) => {
        let isDevicesInit = false;
        if (localStorage.getItem("devices")) {
          const devices = JSON.parse(decodeURIComponent(localStorage.getItem("devices") || ""));
          resolve(devices);
          emits("devicesInit", devices);
          isDevicesInit = true;
        }
        if (!isDevicesInit) {
          const uuid = localStorage.getItem("uuid") || getUuid();
          localStorage.setItem("uuid", uuid);
          request.post(`${USER_SYSTEM_API_HOST(env || "prod")}/frontend/devices/access`).then(({ data }) => {
            var _a;
            request.post(`${USER_SYSTEM_API_HOST(env || "prod")}/frontend/devices/init`, {
              app_version: window.appVersion,
              device_language: ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en",
              device_model: getDeviceInfo().code,
              device_token: uuid,
              device_type: DEVICE_TYPE(env || "prod"),
              device_os: "web",
              device_os_version: "8.0.0",
              access_token: data.data.access_token,
              device_lifetime_id: getCookie("dlt"),
              app_type: "sg",
              platform: PLATFORM(env || "prod", platform)
            }).then(({ data: data2 }) => {
              const devices = { ...data2.data, uuid };
              resolve(devices);
              emits("devicesInit", devices);
              setDevices(devices);
              try {
                localStorage.setItem("devices", encodeURIComponent(JSON.stringify(devices)));
              } catch (error) {
                console.error(error);
              }
            }).catch((error) => reject(error));
          }).catch((error) => reject(error));
        }
      });
    };
    const loginByUser = (reload) => {
      return new Promise((resolve, reject) => {
        setLoginByLoading(true);
        localStorage.removeItem("devices");
        request.get(CUSTOMER_TOKEN(env || "prod")).then(({ data }) => {
          data.session_token = data.token;
          const loginByUser2 = data;
          request.get(`${ANYWHERE_URL(env || "prod")}/api/customer/profile`).then(({ data: data2 }) => {
            const customerProfile = { ...loginByUser2, ...data2.data };
            emits("loginSuccess", customerProfile);
            resolve(customerProfile);
            setUserInfo(customerProfile);
            setLoginByLoading(false);
            setLoginBySuccess(true);
            nextTick(() => {
              setLoginByWaiting(false);
              if (reload)
                window.location.reload();
            });
          }).catch((error) => {
            console.error(error);
            emits("loginSuccess", loginByUser2);
            resolve(loginByUser2);
            setUserInfo(loginByUser2);
            setLoginByLoading(false);
            setLoginBySuccess(true);
            nextTick(() => {
              setLoginByWaiting(false);
              if (reload)
                window.location.reload();
            });
          });
        }).catch((error) => {
          setLoginByLoading(false);
          emits("error", error);
          reject(error);
        });
      });
    };
    const loginByGuest = () => {
      return new Promise((resolve, reject) => {
        setLoginByLoading(true);
        devicesInit().then((devices) => {
          var _a;
          request.post(`${USER_SYSTEM_API_HOST(env || "prod")}/frontend/users/skip`, {
            device_language: ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en",
            device_id: devices.device_id,
            device_token: devices.uuid,
            device_hash: devices.device_hash
          }).then(({ data }) => {
            emits("loginGuestSuccess", data.data);
            resolve(data.data);
            setGuestInfo(data.data);
            setLoginByLoading(false);
            nextTick(() => setLoginByWaiting(false));
          }).catch((error) => {
            setLoginByLoading(false);
            emits("error", error);
            reject(error);
          });
        }).catch((error) => {
          setLoginByLoading(false);
          emits("error", error);
          reject(error);
        });
      });
    };
    const refreshToken = (device_id, user_token) => {
      return new Promise((resolve, reject) => {
        setLoginByLoading(true);
        request.post(`${USER_SYSTEM_API_HOST(env || "prod")}/frontend/devices/refresh_token`, {
          device_id,
          user_token
        }).then(
          ({
            data: {
              data: { refresh_token }
            }
          }) => {
            emits("loginSuccess", { session_token: refresh_token });
            resolve({ session_token: refresh_token });
            setLoginByLoading(false);
          }
        ).catch((error) => {
          emits("error", error);
          reject(error);
          setLoginByLoading(false);
        });
      });
    };
    const onSsoload = () => {
      iframeShow.value = true;
    };
    const loginRegistrationEventListener = async (e) => {
      const loginData = e.data;
      if (["memberzone_return", "close"].includes(loginData)) {
        iframeSrc.value = "";
      }
      if (/^redirect_url:/.test(loginData) && iframeShow.value) {
        window.location.assign(loginData.replace(/^redirect_url:/, ""));
      }
      if (loginData === "login_success") {
        if (!loginByLoading.value) {
          try {
            await loginByUser(true);
            iframeSrc.value = "";
          } catch (error) {
            iframeSrc.value = "";
            console.error(error);
          }
        }
      }
    };
    const userLogin = () => {
      var _a;
      setLoginBySuccess(false);
      emits("userEvent", "USER_LOGIN");
      iframeSrc.value = USER_LOGIN(env || "prod", ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en");
    };
    const userRegistration = () => {
      var _a;
      setLoginBySuccess(false);
      emits("userEvent", "USER_REGISTRATION");
      iframeSrc.value = USER_REGISTRATION(env || "prod", ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en");
    };
    const userMemberzone = () => {
      var _a;
      setLoginBySuccess(false);
      emits("userEvent", "USER_MEMBERZONE");
      iframeSrc.value = USER_MEMBERZONE(env || "prod", ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en");
    };
    const userLogout = () => {
      emits("userEvent", "USER_LOGOUT");
      request.post(CUSTOMER_LOGOUT(env || "prod")).then(() => {
        var _a;
        localStorage.removeItem("devices");
        sessionStorage.removeItem("geoIp");
        deleteCookie("ut");
        deleteCookie("login_by");
        deleteCookie("dlt");
        window.location.assign(USER_LOGOUT(env || "prod", ((_a = currentLanguage == null ? void 0 : currentLanguage.value) == null ? void 0 : _a.code) || "en"));
      }).then((error) => {
        console.error("userLogout:", error);
      });
    };
    watch(iframeSrc, (iframeSrc2) => {
      const htmlEl = document.querySelector("html");
      if (htmlEl == null ? void 0 : htmlEl.style) {
        htmlEl.style.overflow = iframeSrc2 ? "hidden" : "";
      }
      if (!iframeSrc2) {
        iframeShow.value = false;
        emits("close");
      }
    });
    watch(loginBySuccess, (loginBySuccess2) => {
      if (loginBySuccess2)
        iframeSrc.value = "";
    });
    onMounted(() => {
      window.addEventListener("message", loginRegistrationEventListener, false);
      if (getCookie("ut")) {
        if (!loginByLoading.value && !userInfo.value)
          loginByUser(false);
      } else if (!loginByLoading.value && !guestInfo.value) {
        loginByGuest();
      }
    });
    onBeforeUnmount(
      () => window.removeEventListener("message", loginRegistrationEventListener, false)
    );
    const userEvent = () => {
      switch (props.type) {
        case "USER_LOGIN":
          userLogin();
          break;
        case "USER_LOGOUT":
          userLogout();
          break;
        case "USER_MEMBERZONE":
          userMemberzone();
          break;
        case "USER_REGISTRATION":
          userRegistration();
          break;
      }
    };
    expose({
      userLogin,
      userLogout,
      userMemberzone,
      userRegistration,
      getToken: loginByUser,
      refreshToken
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag || void 0), mergeProps(_ctx.$attrs, { onClick: userEvent }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16)),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createElementVNode("div", {
            class: normalizeClass(["tvb-anywhere-sso_dialog animate__fadeIn", { show: !!iframeSrc.value }])
          }, [
            createElementVNode("div", {
              class: normalizeClass(["tvb-anywhere-sso_dialog-container", [__props.animate ? __props.animate : "animate__fadeInDown"]])
            }, [
              createElementVNode("div", _hoisted_1, [
                createElementVNode("img", {
                  class: "tvb-anywhere-sso_dialog-container-loading-img",
                  src: `${unref(PUBLIC_URL)(unref(env) || "prod")}/tvbaw_logo.svg?_t=${unref(getPublishTimestamp)()}`,
                  alt: "tvb anywhere logo",
                  title: "tvb anywhere logo"
                }, null, 8, _hoisted_2)
              ]),
              createElementVNode("span", {
                class: "tvb-anywhere-sso_dialog-container-close",
                onClick: _cache[0] || (_cache[0] = ($event) => iframeSrc.value = "")
              }),
              iframeSrc.value ? (openBlock(), createElementBlock("iframe", {
                key: 0,
                class: "tvb-anywhere-sso_dialog-container-iframe",
                src: iframeSrc.value,
                style: normalizeStyle({ opacity: iframeShow.value ? 1 : 0 }),
                onLoad: onSsoload
              }, null, 44, _hoisted_3)) : createCommentVNode("v-if", true)
            ], 2)
          ], 2)
        ]))
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=SsoButton.vue2.mjs.map
